
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.125 1.25h-.75V0h-1.25v1.25h-8.25V0h-1.25v1.25h-.75A1.877 1.877 0 000 3.125v11C0 15.159.841 16 1.875 16h12.25A1.877 1.877 0 0016 14.125v-11a1.877 1.877 0 00-1.875-1.875zm.625 12.875c0 .345-.28.625-.625.625H1.875a.626.626 0 01-.625-.625v-8.25h13.5v8.25zm0-9.5H1.25v-1.5c0-.345.28-.625.625-.625h.75v1.25h1.25V2.5h8.25v1.25h1.25V2.5h.75c.345 0 .625.28.625.625v1.5z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.372 10.295a.417.417 0 010-.59l2.652-2.651a.417.417 0 01.589.589l-1.94 1.94h8.654l-1.94-1.94a.417.417 0 11.59-.59l2.651 2.652a.417.417 0 010 .59l-2.652 2.651a.416.416 0 11-.589-.589l1.94-1.94H3.673l1.94 1.94a.417.417 0 11-.59.59l-2.651-2.652z","fill":"currentColor"}})])
          )
        }
      }
    